import {useState, useEffect, useLayoutEffect, useRef} from "react";
import "../styles/design.css";

import IdeaStrikeLogoPng from "../data/ideastrike.png";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import MorphImage from "../data/ResourcesPage.jpg";
import MorphImage2 from "../data/PricingPage.jpg";
import MorphImage3 from "../data/FeedbackPage.jpg";
import MorphImage4 from "../data/MainPage.jpg";

import AnitaAuth from "../data/AnitaAuth.jpg";
import AnitaSupport from "../data/AnitaSupport.jpg";
import AnitaSearch from "../data/AnitaSearch.jpg";
import AnitaSearchDoc from "../data/AnitaSearchDoc.jpg";
import AnitaProfile from "../data/AnitaProfile.jpg";
import AnitaHome from "../data/AnitaHome.jpg";

import TI1 from "../data/TrafficInspectorHome.jpg";
import TI2 from "../data/TrafficInspectorTech1.jpg";
import TI3 from "../data/TrafficInspectorTech2.jpg";

gsap.registerPlugin(ScrollTrigger);
function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
}

function DesignPortfolio() {
    const [animationState, setAnimationState] = useState(0);
    const [zoomOut, setZoomOut] = useState(false);
    const {width: w, height: h} = useWindowSize();
    const MIN_H = 743;
    const MIN_W = 1000;


    let mainElement;

    useEffect(()=>{
        if(animationState == 0) {
            new Promise((y)=>setTimeout(y, 3800)).then((x)=>{
                setZoomOut(true);
                if(document.getElementById("welcome-space") && !document.getElementById("welcome-space").getAttribute("touched")) {
                    document.getElementById("welcome-space").classList.add("blur-out");
                }
            });
        }
    }, [animationState]);

    useEffect(()=>{
        if(w < MIN_W || h < MIN_H) {
            window.location.pathname = "/";
        }
    }, [w, h]);

    const container = useRef(null);
    const box = useRef(null);
    // REMOVED: const scroller = useRef(null); // No longer needed
    const containerAnita = useRef(null);
    const containerTI = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container.current,
                    // REMOVED: scroller: scroller.current, // Let GSAP use the Window
                    start: "-24px top",
                    end: "300%",
                    scrub: 0.2,
                    pin: true,
                    // REMOVED: pinType: "transform", // Let GSAP default to "fixed" (much smoother)
                    // REMOVED: anticipatePin: 1, // Not needed for fixed pinning
                    invalidateOnRefresh: true,
                },
            });

            const aP2 = document.querySelector(".animation-pane2");
            const aP2Inner = aP2 ? aP2.querySelector("div") : null;
            
            const tl2 = gsap.timeline({
                scrollTrigger: {
                    trigger: containerAnita.current,
                    start: "-24px top",
                    end: "300%",
                    scrub: 0.2,
                    pin: true,
                    invalidateOnRefresh: true,
                },
            });
            
            tl2.to(aP2, {
                opacity: 1,
                duration: 0.1
            });
            
            if (aP2Inner) {
                tl2.to(aP2Inner, {
                    x: () => -(aP2Inner.scrollWidth - aP2.clientWidth),
                    ease: "none",
                    duration: 1
                }, ">");
            }

            const tl3 = gsap.timeline({
                scrollTrigger: {
                    trigger: containerTI.current,
                    start: "-24px top",
                    end: "100%",
                    scrub: 0.2,
                    pin: true,
                    invalidateOnRefresh: true,
                },
            });
            let ti1 = document.getElementById("ti1");
            let ti2 = document.getElementById("ti2");
            let ti3 = document.getElementById("ti3");
            if(ti1) {
                tl3.to(ti1, {
                    opacity: 1,
                    top: 48,
                    duration: 0.6,
                });
                tl3.to(ti2, {
                    opacity: 1,
                    top: 148,
                    duration: 0.6
                }).to(ti1, {
                    scale: 0.8,
                    top: -48
                }, "<");
                tl3.to(ti3, {
                    opacity: 1,
                    top: 172,
                    duration: 0.6
                }).to(ti1, {

                }, "<").to(ti2, {
                    scale: 0.9,
                    top: 56
                }, "<");
                
            }



            const bMain = document.getElementById("bMain");
            const resourcesPage = document.getElementById("resourcesPage");
            const morphImg = document.getElementById("morphImg");
            const pricingPage = document.getElementById("pricingPage");
            const morphImg2 = document.getElementById("morphImg2");
            const feedbackPage = document.getElementById("feedbackPage");
            const morphImg3 = document.getElementById("morphImg3");
            const mainPage = document.getElementById("mainPage");
            const morphImg4 = document.getElementById("morphImg4");
            const snowflake1 = document.querySelectorAll(".snowflake1");
            const animationPane = document.querySelectorAll(".animation-pane");
            const snowflake2 = document.querySelectorAll(".snowflake2");
            const snowflake3 = document.querySelectorAll(".snowflake3");
            const cssBlock = document.querySelectorAll(".css-block");
            const arrX = document.querySelectorAll(".arrow");
            const arrY = document.querySelectorAll(".arow-text");
            tl.to([bMain, animationPane], {
                scale: 1,
                opacity: 1,
                duration: 0.1
            }, "<").to([snowflake1, snowflake2], {
                opacity: 1,
                width: "100%",
                height: "100%",
                duration: 0.1
            }).to([snowflake3], {
                opacity: 1,
                width: "190%",
                height: "190%",
                top: "-50%",
                left: "-50%"
            }, "<").to([cssBlock], {
                opacity: 1,
                marginRight: "0px"
            }, "<").to([arrX, arrY], {
                opacity: 1,
                "transform": "scale(1)",
                
            }, "<")

            // Get all 7x7 grid elements except the main block (3,3)
            const gridElements = [];
            for (let y = 0; y < 7; y++) {
                for (let x = 0; x < 7; x++) {
                    if (x === 3 && y === 3) continue; // Skip main block
                    const el = document.getElementById(x + "-" + y + "s");
                    if (el) gridElements.push(el);
                }
            }
            
            // Shuffle the array randomly using a seeded approach for consistency
            for (let i = gridElements.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [gridElements[i], gridElements[j]] = [gridElements[j], gridElements[i]];
            }
            
            // Add grid elements to timeline in batches of 3
            for (let i = 0; i < gridElements.length; i += 3) {
                const batch = gridElements.slice(i, i + 3);
                console.log(batch);
                
                tl.to(batch, {
                    opacity: 1,
                    duration: 0.05,
                    ease: "power2.out"
                }, i < 2 ? ">" : "<+=0.02");
                if(i==0){
                    tl.to([cssBlock, arrX, arrY], {
                opacity: 0,
                duration: 0.5
            }, "<");
                }
            }
            
            // Background color animation for grid elements
            const bgColors = [
  "#18392B", // forest
  "#339532", // max-green
  "#c08c1b", // sand
  "#BA5624", // orange
  "#F22B29", // alarm
  "#299797", // ice
  "#38369A", // water
  "#B7245C", // rose
  "#311847"  // violet
];

            
            // Get inner elements (element > child_0 > child_0) for background animation
            const bgElements = [];
            let colorIndex = 8;
            for (let y = 0; y < 7; y++) {
                for (let x = 0; x < 7; x++) {
                    if (x === 3 && y === 3) continue; // Skip main block
                    const el = document.getElementById(x + "-" + y + "s");
                    if (el && el.children[0] && el.children[0].children[0]) {
                        bgElements.push({
                            element: el.children[0].children[0],
                            color: bgColors[colorIndex % bgColors.length]
                        });
                        colorIndex++;
                    }
                }
            }
            
            // Shuffle background elements
            for (let i = bgElements.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [bgElements[i], bgElements[j]] = [bgElements[j], bgElements[i]];
            }
            
            // Animate background colors in batches of 3
            for (let i = 0; i < bgElements.length; i += 3) {
                const batch = bgElements.slice(i, i + 3);
                batch.forEach(item => {
                    let center = item.element.querySelectorAll(".centered-block");
                    tl.to([item.element, ...center], {
                        backgroundColor: item.color,
                        duration: 0.2,
                        ease: "power2.out"
                    }, i === 0 ? ">" : "<+=0.02");
                });
            }
            
            // Animate the main block (3,3) to white
            const mainBlockInner = document.querySelector("#bMain .block-xxy");
            if (mainBlockInner) {
                tl.to(mainBlockInner, {
                    filter: "invert(1)",
                    duration: 0.2,
                    ease: "power2.out"
                }, "<+=0.03");
            }
            
            // Zoom in the main block to fill the container
            const bMainElement = document.getElementById("bMain");
            if (bMainElement) {
                tl.to(bMainElement, {
                    scale: 1,
                    duration: 0.5,
                    ease: "power2.inOut"
                }, ">");
                tl.to(resourcesPage, {
                    opacity: 1,
                    duration: 0.5
                }, ">");
                // Hide surrounding grid elements during zoom
                tl.to(gridElements, {
                    opacity: 0,
                    duration: 0.3,
                    ease: "power2.out"
                }, "<");
            }

            var pane = document.getElementsByClassName("animation-pane");
            pane = pane ? pane.item(0) : undefined;
            if(pane) {
                let w = pane.getBoundingClientRect().width;
                let h = pane.getBoundingClientRect().height;
                let scaleOut = w / 3019;
                tl.to(morphImg, {
                    width: w,
                    height: w * (1941.97 / 3019) < h ? w * (1941.97 / 3019)  : h,
                    marginTop:0,
                    marginLeft:0
                });
                morphImg2.style.width = w + "px";
                tl.to([pricingPage], {
                    opacity: 1
                }).to(morphImg2,{
                    marginTop: (w * (1941.97 / 3019) < h ? w * (1941.97 / 3019)  : h) / 20,
                    opacity: 1,
                    

                }, "<").to(bMainElement, {
                    opacity: 0
                }, "<");
                morphImg3.style.width = w + "px";
                morphImg3.style.marginTop = "120px"
                morphImg4.style.width = w + "px";
                morphImg4.style.marginTop = "120px"
                tl.to([feedbackPage], {
                    opacity: 1
                }).to(morphImg3,{
                    marginTop: (w * (1941.97 / 3019) < h ? w * (1941.97 / 3019)  : h) / 20,
                    opacity: 1,
                    

                }, "<");

                tl.to([mainPage], {
                    opacity: 1
                }).to(morphImg4,{
                    marginTop: (w * (1941.97 / 3019) < h ? w * (1941.97 / 3019)  : h) / 15,
                    opacity: 1,
                }, "<");

                /*tl.to([pricingPage, feedbackPage, resourcesPage], {
                    opacity: 0,
                    duration: 0.05,
                    ease: "power2.out"
                }).to([mainPage], {
                    opacity: 0,
                    duration: 0.05 ,
                    ease: "power2.out"
                }, "<").to([pricingPage, feedbackPage, resourcesPage, mainPage, ...gridElements, bMainElement],{
                    visibility: "hidden"
                }, "<");*/
            }

            // KEYFRAMES
           
            // bMain background animation
        
        }, container);

        return () => ctx.revert();
    }, []);

    // ... (Your mainElement logic remains exactly the same) ...
    if(animationState == 0) {
        mainElement = <div id="welcome-space" onMouseOver={(e)=>{   
                if(!zoomOut)return;
                let wC = document.getElementById("welcome-space");             
                wC.classList.remove("blur-out");
                wC.classList.add("blur-in");
                wC.setAttribute("touched", true);
            }} onMouseLeave={(e)=>{
                let wC = document.getElementById("welcome-space");
                wC.classList.remove("blur-in");
                wC.classList.add("blur-out");
                wC.setAttribute("touched", true);
            }}>
            <div id="w" style={{"marginBottom": zoomOut && "180px", "justifyContent": zoomOut ? "end" : ""}} className={zoomOut ? "fade-inx": ""}>
            {["Welcome", "Bending Spoons", "to", "my", "design", "portfolio"].map((element, index)=>{
                let focus = element == "Bending Spoons";
                let speed = 220;
                if(!focus) {
                    return <div className="welcome-text" key={index} style={{"animationDelay": ((index ^ 0.3) * speed) + "ms", "fontSize": zoomOut && "1.8rem"}}>{element}</div>
                }else{
                    return <div className="welcome-text bending-spoon-text" key={index} style={{"animationDelay": ((index^0.3) * speed) + "ms", "fontSize": zoomOut ? "1.8rem" : "3.2rem"}}>{element}</div>
                }
            })}
            </div>
        
            <div style={{"position": "absolute", "bottom": "-200px", "left": "-37px", "right": "-100px", "overflow": "hidden", "top": "0px", "zIndex": -1}} className={zoomOut ? "fade-inx" : "hidden"}>
                <Perspective3DCanvas id={"310297492837"} bgs={["#444", "#444", "#444"]}></Perspective3DCanvas>
            </div>
        </div>
    }    

    // ... (Your coperE logic remains exactly the same) ...
    let coperE = <div className="var-zz" >
        <div className="var-ws">
        <div className="variable-ws" id="id0" onMouseOver={(e)=>{   
                let wC = document.getElementById("id0");             
                wC.classList.remove("blur-out");
                wC.classList.add("blur-in");
                wC.setAttribute("touched", true);
            }} onMouseLeave={(e)=>{
                let wC = document.getElementById("id0");
                wC.classList.remove("blur-in");
                wC.classList.add("blur-out");
                wC.setAttribute("touched", true);
            }}>
                

                <div style={{"position": "absolute", "bottom": "-10px", "right": "-25px", "overflow": "hidden", "top": "0px", "zIndex": -1, "transform": "scale(-1,1)", "overflow": "hidden"}} className={zoomOut ? "fade-inx" : "hidden"}>
                    <Perspective3DCanvas height={300}  width={800} id={"492387492387498"} bgs={w > 1800 ? ["#444", "#444", "#444"] : ["#e37ad5aa", "#8598ffaa"]}></Perspective3DCanvas>
                </div>
            </div>
            {zoomOut ? <div style={{"position": "absolute", "top": "0px", "right": "0px", "left": "0px", "bottom": "0px", "justifyContent": "start", "display": "flex", "alignItems": "left", "flexDirection": "column", "pointerEvents": "none", "padding": "16px 32px"}}>
                <div className="big-text1">
                    {"Jim-Linus Valentin Ahrend"}
                    <div id="underliner-0"></div>
                </div>
                <div className="small-text1">
                    {"Think. Design. Build. Ship."}
                </div>
            </div> : ""}
            </div>
        {mainElement}
    </div>

    // ... (Your ideaStrikeInterface logic remains exactly the same) ...
    let ideaStrikeInterface = <div ref={container} className="full-var" id="id1" onMouseOver={(e)=>{   
                let wC = document.getElementById("id1");             
                wC.classList.remove("blur-out");
                wC.classList.add("blur-in");
                wC.setAttribute("touched", true);
            }} onMouseLeave={(e)=>{
                let wC = document.getElementById("id1");
                wC.classList.remove("blur-in");
                wC.classList.add("blur-out");
                wC.setAttribute("touched", true);
            }}>
             
        <div className="inner-fv" style={{"borderColor": "rgba(51, 51, 51, 0.75)"}}>
            <div className="inner-fv" style={{"borderColor": "rgba(51, 51, 51, 0.5)", "paddingLeft": "24px", "width": "calc(100% - 24px - 10px)"}}>
                <div className="side-info">
                     <img id="islogo" src={IdeaStrikeLogoPng} loading="lazy"></img>
                     <div className="logo-block">{"The block-based idea editor"}</div>
                     <div className="logo-block">{"Developed in 2025"}</div>
                     <div className="logo-block"><a href="https://ideastrike.co" target="_blank">{"ideastrike.co"}</a></div>
                </div>
                <div className="animation-pane">

                    {/**First pane */}
                <div style={{"display": "flex", "gap": "12px", "position": "absolute", "top": "50%", "left": "50%", "transform": "translate(-50%, -50%)"}}>{Array.from({length: 7}, (_, y) => y).map((y)=>{
                        return <div style={{"display": "flex", "flexDirection": "column", "gap": "12px"}} key={y}>{Array.from({length: 7}, (_, x) => x).map((x)=>{
                            let isMainBlock = x == 3 && y == 3;
                            
                            // Block type assignments - each cell gets a block type (A-G) based on position
                            // Pattern repeats to fill all cells, main block excluded
                            const blockPatterns = [
    [[0,0,'G'], [0,1,'E'], [0,2,'C'], [0,3,'A'], [0,4,'F'], [0,5,'D'], [0,6,'B']],
    [[1,0,'B'], [1,1,'G'], [1,2,'D'], [1,3,'B'], [1,4,'H'], [1,5,'G'], [1,6,'E']],
    [[2,0,'D'], [2,1,'A'], [2,2,'F'], [2,3,'I'], [2,4,'C'], [2,5,'A'], [2,6,'F']],
    [[3,0,'F'], [3,1,'C'], [3,2,'G'], /* X */ [3,4,'E'], [3,5,'B'], [3,6,'G']],
    [[4,0,'A'], [4,1,'E'], [4,2,'B'], [4,3,'D'], [4,4,'B'], [4,5,'D'], [4,6,'C']],
    [[5,0,'G'], [5,1,'D'], [5,2,'F'], [5,3,'H'], [5,4,'A'], [5,5,'F'], [5,6,'E']],
    [[6,0,'C'], [6,1,'B'], [6,2,'A'], [6,3,'E'], [6,4,'C'], [6,5,'B'], [6,6,'G']],
];
                            
                            const getBlockType = (px, py) => {
                                const row = blockPatterns[py];
                                if (!row) return null;
                                const cell = row.find(([cy, cx]) => cx === px && cy === py);
                                return cell ? cell[2] : null;
                            };
                            
                            const blockType = isMainBlock ? null : getBlockType(x, y);
                            const blockA = blockType === 'A';
                            const blockB = blockType === 'B';
                            const blockC = blockType === 'C';
                            const blockD = blockType === 'D';
                            const blockE = blockType === 'E';
                            const blockF = blockType === 'F';
                            const blockG = blockType === 'G';
                            const blockH = blockType === 'H';
                            const blockI = blockType === 'I';
                            
                            let rotation = x < 4 ? "45deg": (y <4 ? "135deg": (x >= 4 ? "-45deg" : "215deg"));
                            return <div id={x+"-"+y+"s"} className={!isMainBlock && "op0"} style={{"position": "relative", "zIndex": isMainBlock && "100"}}><div key={x} id={isMainBlock && "bMain"} className="block-yyy">
                                <div className="block-xxy"  >
                                    {isMainBlock && <div className="text-block-a">{"Welcome to IdeaStrike"}</div>}
                                    {isMainBlock && <div className="text-block-b">{"This is a space for creativity + innovation"}</div>}
                                    {isMainBlock && <div className="text-block-c"></div>}
                                    {isMainBlock && <div className="text-block-d">{"Blocks include small packages of information. Blocks can have various designs, generated by AI, different colors, images, links and more"}</div>}
                                    {blockA && <div className="op10" style={{color: "rgb(255, 255, 255)", textDecorationColor: "rgb(17, 17, 17)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%"}}><div draggable="true" className="lsxx xx-description"><span><span><span>User Feedback</span></span></span></div><div style={{}}><div draggable="true" className="lsxx xx-quote" style={{borderLeft: "1px solid rgba(255, 255, 255, 0.667)", paddingLeft: "8px"}}><div className="xx-text"><span><span><span><span>I really enjoyed the keyboard-first approach. "The fact that you can do everything by keyboard, makes creative work with IdeaStrike so much faster and lighter"</span></span></span></span></div></div></div></div>}
                                    {blockB && <div className="op10" style={{color: "rgb(255, 255, 255)", textDecorationColor: "rgb(17, 17, 17)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%"}}><div draggable="true" className="lsxx xx-subheader"><span><span><span>TODO;</span></span></span></div><div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "start", alignItems: "start"}} className="lsxx xx-clist" draggable="true"><span><span><span>Build a website</span></span></span><div className="checklist-checker "></div></div><div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "start", alignItems: "start"}} className="lsxx xx-clist" draggable="true"><span><span><span>Implement a backend arch approach</span></span></span><div className="checklist-checker "></div></div><div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "start", alignItems: "start"}} className="lsxx xx-clist" draggable="true"><span><span><span>Handle client calls</span></span></span><div className="checklist-checker "></div></div><div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "start", alignItems: "start"}} className="lsxx xx-clist" draggable="true"><span><span><span>Visit lecture at university</span></span></span><div className="checklist-checker "></div></div><div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "start", alignItems: "start"}} className="lsxx xx-clist" draggable="true"><span><span><span>Structure payables</span></span></span><div className="checklist-checker "></div></div><div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "start", alignItems: "start"}} className="lsxx xx-clist" draggable="true"><span><span><span>Enjoy a hot pasta at Toni O</span></span></span><div className="checklist-checker "></div></div><div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "start", alignItems: "start"}} className="lsxx xx-clist" draggable="true"><span><span><span>View FCB vs. Inter Milan</span></span></span><div className="checklist-checker "></div></div><div style={{display: "flex", flexDirection: "row-reverse", justifyContent: "start", alignItems: "start"}} className="lsxx xx-clist" draggable="true"><span><span><span>Midnight snack with friends</span></span></span><div className="checklist-checker "></div></div></div>}
                                    {blockC && <div className="op10" style={{color: "rgb(255, 255, 255)", textDecorationColor: "rgb(56, 54, 154)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%"}}><div draggable="true" className="lsxx xx-link-1 n-1" style={{color: "white"}}><div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "32px", height: "32px", backgroundColor: "white", borderRadius: "3px", opacity: 0.9, padding: "2px"}}><img width="30" height="30" src="https://www.google.com/s2/favicons?sz=64&amp;domain_url=valentinahrend.com"></img></div><div className="link-body"><div className="link-header"><span><span><span>valentinahrend.com</span></span></span></div></div><div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%", marginLeft: "auto", gap: "7px", fontWeight: 600, fontFamily: "monospace", whiteSpace: "nowrap", overflow: "hidden"}}><span style={{opacity: 0.2}}>1</span><span style={{opacity: 1}}>1</span><span style={{opacity: 0.2}}>1</span></div></div><div draggable="true" className="lsxx xx-description"><span><span><span>Portfolio Website</span></span></span></div><div draggable="true" className="lsxx xx-text"><span><span><span>This website includes projects, information about me, goals and ideas.</span></span></span></div><div className="element-add dissolve" style={{border: "1px solid transparent"}}>Add structural element</div></div>}  
                                    {blockD && <div className="op10" style={{color: "rgb(255, 255, 255)", textDecorationColor: "rgb(17, 17, 17)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%"}}><div className="lsxx xx-img" draggable="true"><svg style={{"height": "100px", "margin": "auto"}}><path xmlns="http://www.w3.org/2000/svg" d="M47.9468 49.1477L57.3574 64.8295M47.9468 49.1477L38.7072 65.5114M47.9468 49.1477L38.7072 33.4659M47.9468 49.1477L56.673 32.9545M47.9468 49.1477L29.1255 50M47.9468 49.1477H66.2548M57.3574 64.8295L48.8023 76.9318M57.3574 64.8295L66.2548 49.1477M57.3574 64.8295L74.981 63.9773M57.3574 64.8295L63.6882 78.2955M57.3574 64.8295L38.7072 65.5114M48.8023 76.9318L38.7072 65.5114M48.8023 76.9318L63.6882 78.2955M48.8023 76.9318L49.6578 88.1818M48.8023 76.9318L33.5741 79.4886M38.7072 65.5114L33.5741 79.4886M38.7072 65.5114L29.1255 50M38.7072 65.5114L21.9392 64.8295M38.7072 33.4659L47.9468 18.8068M38.7072 33.4659L29.1255 50M38.7072 33.4659L29.1255 22.0455M38.7072 33.4659L23.6502 36.1932M38.7072 33.4659L56.673 32.9545M47.9468 18.8068L56.673 32.9545M47.9468 18.8068L57.3574 9.43182M47.9468 18.8068L66.2548 21.1932M47.9468 18.8068L29.1255 22.0455M47.9468 18.8068L38.8783 10.1136M56.673 32.9545L71.9011 35M56.673 32.9545L66.2548 21.1932M56.673 32.9545L66.2548 49.1477M66.2548 49.1477L71.9011 35M66.2548 49.1477L81.8251 46.4205M66.2548 49.1477L74.981 63.9773M71.9011 35L81.8251 29.375M71.9011 35L81.8251 46.4205M71.9011 35L66.2548 21.1932M66.2548 21.1932L57.3574 9.43182M66.2548 21.1932L74.981 14.8864M66.2548 21.1932L81.8251 29.375M57.3574 9.43182L74.981 14.8864M57.3574 9.43182L47.9468 5M57.3574 9.43182L38.8783 10.1136M57.3574 9.43182L63.6882 6.02273M29.1255 22.0455L23.6502 36.1932M29.1255 22.0455L21.9392 16.4205M29.1255 22.0455L38.8783 10.1136M29.1255 22.0455L14.924 31.0795M23.6502 36.1932L29.1255 50M23.6502 36.1932L14.924 47.9545M23.6502 36.1932L14.924 31.0795M36.1407 93.4659L33.5741 90.2273M36.1407 93.4659L20.3992 85.1136M36.1407 93.4659L50.5133 95M33.5741 90.2273L20.3992 85.1136M33.5741 90.2273L49.6578 88.1818M33.5741 90.2273V79.4886M33.5741 90.2273L50.5133 95M33.5741 90.2273L19.3726 78.2955M20.3992 85.1136L19.3726 78.2955M20.3992 85.1136L10.9886 72.8409M19.3726 78.2955L10.9886 72.8409M19.3726 78.2955L21.9392 64.8295M19.3726 78.2955L33.5741 79.4886M19.3726 78.2955L10.1331 62.4432M10.9886 72.8409L10.1331 62.4432M10.9886 72.8409L5 59.5455M10.1331 62.4432L5 59.5455M10.1331 62.4432L21.9392 64.8295M10.1331 62.4432L14.924 47.9545M10.1331 62.4432L6.36882 45.2273M5 59.5455L6.36882 45.2273M5 59.5455V42.5M6.36882 45.2273L5 42.5M6.36882 45.2273L14.924 47.9545M6.36882 45.2273L14.924 31.0795M6.36882 45.2273L10.1331 28.3523M5 42.5L10.1331 28.3523M10.1331 28.3523L14.924 31.0795M10.1331 28.3523L19.3726 16.4205M10.1331 28.3523L21.9392 16.4205M14.924 31.0795V47.9545M14.924 31.0795L21.9392 16.4205M14.924 47.9545L21.9392 64.8295M14.924 47.9545L29.1255 50M21.9392 64.8295L33.5741 79.4886M21.9392 64.8295L29.1255 50M50.5133 95L66.2548 92.6136M50.5133 95L49.6578 88.1818M50.5133 95L66.2548 89.375M66.2548 92.6136V89.375M66.2548 92.6136L80.1141 83.75M66.2548 89.375L49.6578 88.1818M66.2548 89.375L63.6882 78.2955M66.2548 89.375L80.1141 83.75M66.2548 89.375L79.2586 76.9318M49.6578 88.1818L33.5741 79.4886M49.6578 88.1818L63.6882 78.2955M21.9392 16.4205H19.3726M21.9392 16.4205L33.5741 6.875M21.9392 16.4205L38.8783 10.1136M19.3726 16.4205L33.5741 6.875M38.8783 10.1136L33.5741 6.875M38.8783 10.1136L47.9468 5M33.5741 6.875L47.9468 5M47.9468 5L63.6882 6.02273M63.6882 6.02273L74.981 14.8864M63.6882 6.02273L79.2586 14.8864M74.981 14.8864H79.2586M74.981 14.8864L81.8251 29.375M74.981 14.8864L88.6692 26.9886M79.2586 14.8864L88.6692 26.9886M81.8251 29.375L88.6692 26.9886M81.8251 29.375V46.4205M81.8251 29.375L91.9202 42.5M88.6692 26.9886L95 40.1136M88.6692 26.9886L91.9202 42.5M81.8251 46.4205L74.981 63.9773M81.8251 46.4205L91.9202 42.5M81.8251 46.4205L88.6692 60.7386M74.981 63.9773L88.6692 60.7386M74.981 63.9773L63.6882 78.2955M74.981 63.9773L79.2586 76.9318M88.6692 60.7386L91.9202 42.5M88.6692 60.7386V71.1364M88.6692 60.7386L79.2586 76.9318M91.9202 42.5L95 40.1136M91.9202 42.5L95 57.5M95 40.1136V57.5M63.6882 78.2955L79.2586 76.9318M80.1141 83.75L89.6958 71.8182M80.1141 83.75L79.2586 76.9318M80.1141 83.75L88.6692 71.1364M89.6958 71.8182L88.6692 71.1364M89.6958 71.8182L95 57.5M88.6692 71.1364L95 57.5M88.6692 71.1364L79.2586 76.9318" stroke="#EA006D" stroke-width="2"/></svg></div><div draggable="true" className="lsxx xx-description"><span><span><span>MetaStructure Auth</span></span></span></div><div draggable="true" className="lsxx xx-text"><span><span><span>IdeaStrike is connected to MetaStructure, which is a workspace for design-forward, ai-focused applications.</span></span></span></div></div>}
                                    {blockE && <div className="op10" style={{ color: "rgb(255, 255, 255)", textDecorationColor: "rgb(17, 17, 17)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%" }}><div draggable="true" className="lsxx xx-subheader"><span><span><span>Idea Decision</span></span></span></div><div draggable="true" className="lsxx xx-text"><span><span><span>What is the best option to perform design changes</span></span></span></div><div draggable="true" className="lsxx" style={{ width: "100%" }}><div className="centered-text"><div className="abs-divider" style={{ background: "rgb(255, 255, 255)" }}></div><div className="centered-block" style={{ maxWidth: "260px" }}><span><span><span>Option 1</span></span></span></div></div></div><div draggable="true" className="lsxx xx-text"><span><span><span>Change design in Figma, document it later and analyze UX in prod</span></span></span></div><div draggable="true" className="lsxx" style={{ width: "100%" }}><div className="centered-text"><div className="abs-divider" style={{ background: "rgb(255, 255, 255)" }}></div><div className="centered-block" style={{ maxWidth: "260px" }}><span><span><span>Option 2</span></span></span></div></div></div><div draggable="true" className="lsxx xx-text"><span><span><span>Create design strategy, implement in Figma, test in Dev, UX Research</span></span></span></div></div>}
                                    {blockF && <div className="op10" style={{color: "rgb(255, 255, 255)", textDecorationColor: "rgb(17, 17, 17)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%"}}><div draggable="true" className="lsxx xx-text"><span><span><span>Website design is critical for a successful sales approach. Design is the magic that links information with action, the magic that is needed for a user interface with good user retention, responsiveness and system intelligence</span></span></span></div><div draggable="true" className="lsxx xx-divider" style={{background: "rgb(255, 255, 255)"}}><span><span><span></span></span></span></div><div draggable="true" className="lsxx xx-text"><span><span><span>This IdeaBlock was made by Valentin Ahrend and is part of this IdeaBoard. The design is simple but powerful, elegant but rich of information.</span></span></span></div><div style={{cursor: "pointer", border: "1px solid transparent", background: "rgb(34, 34, 34)", color: "white"}} className="lsxx xx-ref xx-ref-view" draggable="true"><div style={{display: "flex", alignItems: "center", margin: "auto 0px", pointerEvents: "none"}}><img width="14" height="14" src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='iso-8859-1'?%3e%3c!--%20Uploaded%20to:%20SVG%20Repo,%20www.svgrepo.com,%20Generator:%20SVG%20Repo%20Mixer%20Tools%20--%3e%3csvg%20fill='white'%20height='800px'%20width='800px'%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%20330%20330'%20xml:space='preserve'%3e%3cpath%20id='XMLID_224_'%20d='M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394%20l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393%20C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z'/%3e%3c/svg%3e" style={{rotate: "90deg", pointerEvents: "none"}} /><img width="14" height="14" src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='iso-8859-1'?%3e%3c!--%20Uploaded%20to:%20SVG%20Repo,%20www.svgrepo.com,%20Generator:%20SVG%20Repo%20Mixer%20Tools%20--%3e%3csvg%20fill='white'%20height='800px'%20width='800px'%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%20330%20330'%20xml:space='preserve'%3e%3cpath%20id='XMLID_224_'%20d='M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394%20l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393%20C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z'/%3e%3c/svg%3e" style={{rotate: "90deg", marginLeft: "-8px", pointerEvents: "none"}} /><img width="14" height="14" src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='iso-8859-1'?%3e%3c!--%20Uploaded%20to:%20SVG%20Repo,%20www.svgrepo.com,%20Generator:%20SVG%20Repo%20Mixer%20Tools%20--%3e%3csvg%20fill='white'%20height='800px'%20width='800px'%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%20330%20330'%20xml:space='preserve'%3e%3cpath%20id='XMLID_224_'%20d='M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394%20l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393%20C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z'/%3e%3c/svg%3e" style={{rotate: "90deg", marginLeft: "-8px", pointerEvents: "none"}} /></div><div style={{fontSize: "1rem", pointerEvents: "none"}}>Reference: User Feedback; I really enjoyed the keyboard-first approach. "The fact that you can do everything by keyboard, makes creative work with IdeaStrike so much faster and lighter"</div></div></div>}
                                    {blockG && <div className="op10" style={{color: "rgb(255, 255, 255)", textDecorationColor: "rgb(17, 17, 17)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%"}}><div draggable="true" className="lsxx xx-header"><span><span><span>:-)</span></span></span></div></div>}
                                    {blockH && <div className="op10" style={{color: "rgb(255, 255, 255)", textDecorationColor: "rgb(17, 17, 17)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%"}}><div draggable="true" className="lsxx xx-description"><span><span style={{display: "inline-block"}}>1. </span><span style={{paddingLeft: "8px"}}><span>Innovation through design</span></span></span></div><div draggable="true" className="lsxx xx-description"><span><span style={{display: "inline-block"}}>2. </span><span style={{paddingLeft: "8px"}}><span>Creativity in optical illusions</span></span></span></div><div draggable="true" className="lsxx xx-description"><span><span style={{display: "inline-block"}}>3. </span><span style={{paddingLeft: "8px"}}><span>Useful CSS-Libraries</span></span></span></div><div draggable="true" className="lsxx xx-description"><span><span style={{display: "inline-block"}}>4. </span><span style={{paddingLeft: "8px"}}><span>Figma, Adobe and more</span></span></span></div><div draggable="true" className="lsxx xx-description"><span><span style={{display: "inline-block"}}>5. </span><span style={{paddingLeft: "8px"}}><span>Shipping design fast</span></span></span></div></div>}
                                    {blockI &&  <div className="op10" style={{color: "rgb(200, 200, 200)", textDecorationColor: "rgb(17, 17, 17)", display: "flex", flexDirection: "column", gap: "6px", alignItems: "start", width: "100%"}}><div draggable="true" className="lsxx xx-description"><span><span><span>Building this block using Gemini...</span></span></span></div></div>}
                                </div>
                                
                                {isMainBlock && <div className="snowflake1"></div>}
                                {isMainBlock && <div className="snowflake2"></div>}
                                {!isMainBlock && <div className="snowflake3" style={{"transform": "rotate(" + rotation + ")"}}></div>}
                            </div>
                            {isMainBlock && <div className="arr-fx">
                                <div class="arrow"></div>
                                <div className="arow-text">{"333.0"}</div>
                                </div>}
                            {isMainBlock && <div className="arr-fy">
                                <div class="arrow"></div>
                                <div className="arow-text">{"333.0"}</div>
                                </div>}
                            {isMainBlock && <div className="css-block" style={{"top": "-10px", "width": "260px"}}>
                               <div className="css-header">{".xx-header"}</div>
                               <div className="css-description">{"Geist (600), 44px, #Header"}</div>
                            </div>}
                            {isMainBlock && <div className="css-block" style={{"top": "74px", "width": "230px", "right": "314px"}}>
                               <div className="css-header">{".xx-description"}</div>
                               <div className="css-description">{"Geist (600), 24px, #Subheader"}</div>
                            </div>}
                            {isMainBlock && <div className="css-block" style={{"top": "158px", "width": "200px", "right": "304px"}}>
                               <div className="css-header">{".xx-divider"}</div>
                               <div className="css-description">{"#HorizontalDivider"}</div>
                            </div>}
                            {isMainBlock && <div className="css-block" style={{"top": "242px", "width": "170px", "right": "294px"}}>
                               <div className="css-header">{".xx-body"}</div>
                               <div className="css-description">{"Geist (500), 16px, #Text"}</div>
                            </div>}
                            </div>
                        })}</div>
                    })}</div>

                <div id="resourcesPage">
                    <img src={MorphImage} width={3019} height={1941.97 } style={{"aspectRatio": "1 / 1"}} id="morphImg"></img>
                </div>
                <div id="pricingPage">
                    <img src={MorphImage2} width={3019} height={1941.97 } style={{"aspectRatio": "1 / 1"}} id="morphImg2"></img>
                </div>
                <div id="feedbackPage">
                    <img src={MorphImage3} width={3019} height={1941.97 } style={{"aspectRatio": "1 / 1"}} id="morphImg3"></img>
                </div>
                <div id="mainPage">
                    <img src={MorphImage4} width={3019} height={1941.97 } style={{"aspectRatio": "1 / 1"}} id="morphImg4"></img>
                </div>
                <div className="ideasMatter">
                    <a href="https://ideastrike.co" target="_blank" style={{"fontSize": "4rem", "fontFamily": "Geist", "color": "white", "fontWeight": "600", "textDecoration": "underline", "textDecorationColor": "inherit"}}>{"Ideas matter."}</a>
                </div>
                </div>
            </div>
      
        </div>
    </div>

    let anitaLegalInterface = <div className="full-var" ref={containerAnita} id="idx" onMouseOver={(e)=>{   
                let wC = document.getElementById("idx");             
                wC.classList.remove("blur-out");
                wC.classList.add("blur-in");
                wC.setAttribute("touched", true);
            }} onMouseLeave={(e)=>{
                let wC = document.getElementById("idx");
                wC.classList.remove("blur-in");
                wC.classList.add("blur-out");
                wC.setAttribute("touched", true);
            }}>
             
        <div className="inner-fv" style={{"borderColor": "rgba(51, 51, 51, 0.75)"}}>
            <div className="inner-fv" style={{"borderColor": "rgba(51, 51, 51, 0.5)", "paddingLeft": "24px", "width": "calc(100% - 24px - 10px)"}}>
                <div className="side-info" style={{"maxWidth": "320px", "minWidth": "250px"}}>
                     <div className="logo-text">{"Anita.legal Platform"}</div>
                     <div className="logo-block">{"Platform for legal research and document analysis"}</div>
                     <div className="logo-block">{"Frontend developed from 2022-2026"}</div>
                     <div className="logo-block"><a href="https://anita.legal" target="_blank">{"anita.legal"}</a></div>
                </div>
                <div className="animation-pane2">

                    <div style={{"display": "flex", "gap": "24px",  "height": "100%", "width": "fit-content"}}>
                        <img style={{"width": "100%", "height": "fit-content", "maxHeight": "100%", "marginTop": "auto", "marginBottom": "auto"}} src={AnitaAuth}></img>
                        <img style={{"width": "100%", "height": "fit-content", "maxHeight": "100%", "marginTop": "auto", "marginBottom": "auto"}} src={AnitaHome}></img>
                        <img style={{"width": "100%", "height": "fit-content", "maxHeight": "100%", "marginTop": "auto", "marginBottom": "auto"}} src={AnitaSearch}></img>
                        <img style={{"width": "100%", "height": "fit-content", "maxHeight": "100%", "marginTop": "auto", "marginBottom": "auto"}} src={AnitaSearchDoc}></img>
                        <img style={{"width": "100%", "height": "fit-content", "maxHeight": "100%", "marginTop": "auto", "marginBottom": "auto"}} src={AnitaProfile}></img>
                        <img style={{"width": "100%", "height": "fit-content", "maxHeight": "100%", "marginTop": "auto", "marginBottom": "auto"}} src={AnitaSupport}></img>

                    </div>

                </div>
            </div>
      
        </div>
    </div>

    let trafficInspector = <div className="full-var2" ref={containerTI} id="idy" onMouseOver={(e)=>{   
                let wC = document.getElementById("idy");             
                wC.classList.remove("blur-out");
                wC.classList.add("blur-in");
                wC.setAttribute("touched", true);
            }} onMouseLeave={(e)=>{
                let wC = document.getElementById("idy");
                wC.classList.remove("blur-in");
                wC.classList.add("blur-out");
                wC.setAttribute("touched", true);
            }}>
            
            <div style={{"fontSize": "3rem", "fontFamily": "Geist", "color": "white", "fontWeight": "600", "textDecoration": "none", "textDecorationColor": "inherit", "margin": "0px auto"}}>{"TrafficInspector"}</div>
            <div style={{"fontSize": "1.3rem", "marginTop": "8px","fontFamily": "Geist", "color": "#ccc", "fontWeight": "400", "textDecoration": "none", "textDecorationColor": "inherit", "margin": "0px auto"}}>{"Platform for traffic analysis for low-resolution videos"}{" | "}{"Developed in 2024"}{" | "}{"Private product"}</div>
    
            <div style={{"width": "100%", "height": "100%", "position": "relative"}}>

                <img src={TI1} id="ti1" style={{"maxHeight": "calc(100% - 64px)", "left": "50%", "position": "absolute", "top": "320px" , "opacity": 0,"transform": "translateX(-50%)", "margin": "0px auto", "border": "1px solid #333"}}></img>
                <img src={TI2} id="ti2" style={{"maxHeight": "calc(100% - 64px)", "left": "50%", "position": "absolute", "top": "320px" , "opacity": 0,"transform": "translateX(-50%)", "margin": "0px auto", "border": "1px solid #333"}}></img>
                <img src={TI3} id="ti3" style={{"maxHeight": "calc(100% - 64px)", "left": "50%", "position": "absolute", "top": "320px" , "opacity": 0,"transform": "translateX(-50%)", "margin": "0px auto", "border": "1px solid #333"}}></img>

            </div>
    </div>

    let bottom = <div className="full-var2" id="idz" style={{ "display": "flex", "justifyContent": "start"}} onMouseOver={(e)=>{   
                let wC = document.getElementById("idz");             
                wC.classList.remove("blur-out");
                wC.classList.add("blur-in");
                wC.setAttribute("touched", true);
            }} onMouseLeave={(e)=>{
                let wC = document.getElementById("idz");
                wC.classList.remove("blur-in");
                wC.classList.add("blur-out");
                wC.setAttribute("touched", true);
            }}>
         <div style={{"fontSize": "3rem", "marginTop": "12px", "fontFamily": "Geist", "color": "white", "fontWeight": "600", "textDecoration": "none", "textDecorationColor": "inherit", "margin": "0px auto"}}>{"More projects on "}<a href="/">valentinahrend.com</a></div>
            <div style={{"fontSize": "1.3rem", "marginTop": "8px", "maxWidth": "800px", "textAlign": "center", "fontFamily": "Geist", "color": "#ccc", "fontWeight": "400", "textDecoration": "none", "textDecorationColor": "inherit", "margin": "0px auto"}}>{"Over the years my portfolio projects underwent various changes. If you are interested in my development as a developer and desiger, you might take a look at the "}<a href="/v0" target="_blank" style={{"color": "white"}}>{"initial"}</a>{", "}<a style={{"color": "white"}} target="_blank" href="/v1">{"second"}</a>{" and "}<a style={{"color": "white"}} target="_blank" href="/">{"current"}</a>{" version of valentinahrend.com. "}</div>
            <hr style={{"width": "800px", "margin": "32px auto", "borderColor": "#333"}}></hr>
            <div style={{"fontSize": "1.3rem", "marginTop": "8px", "maxWidth": "800px", "textAlign": "center", "fontFamily": "Geist", "color": "#ccc", "fontWeight": "400", "textDecoration": "none", "textDecorationColor": "inherit", "margin": "0px auto"}}>{"Thank you for your attention. This is not my main portfolio, as I've just created it for my application to the First Design Challange from "}<a href="https://firstdesign.bendingspoons.com/" target="_blank" style={{"color": "white"}}>Bending Spoons</a>{". The intention behind this application-specific apporach is to showcase my design skills in a more visual and creative way."}</div>
    </div>

    // REMOVE ref={scroller} from the returned div
    return <div className="house"><div className="garden">{coperE}<div style={{"height": "400vh"}}>{ideaStrikeInterface}</div><div style={{"height": "400vh"}}>{anitaLegalInterface}</div><div style={{"height": "200vh"}}>{trafficInspector}</div>{bottom}</div></div>
}

function Perspective3DCanvas({ width = 1200, height = 300, id, bgs }) {
    const canvasRef = useState(null)[1];
    
    useEffect(() => {
        const canvas = document.getElementById(id);
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        let animationId;
        let offset = 0;
        
        const draw = () => {
            ctx.clearRect(0, 0, width, height);
            
            // Mirror line is the diagonal from top-left to bottom-right
            // Grid expands from bottom-left corner with vanishing point at top-right
            const vanishingPointX = width;
            const vanishingPointY = 0;
            
            // Create gradient for lines
            const gradient = ctx.createLinearGradient(0, height, width, 0);
            bgs.forEach((b, i)=>{
                gradient.addColorStop(0 + 0.5*i, b);
            });
            
            
            ctx.strokeStyle = gradient;
            
            // Draw horizontal lines (receding into distance toward top-right)
            const numHorizontalLines = 19;
            for (let i = 0; i < numHorizontalLines; i++) {
                const t = (i + (offset % 1)) / numHorizontalLines;
                const perspectiveScale = Math.pow(t, 1.8);
                
                // Lines go from left edge toward the vanishing point
                const y = height - (height * perspectiveScale);
                const leftX = 0;
                // Right X stops at the diagonal mirror line (x = width - y for a 45° diagonal)
                const rightX = Math.min(width - y, width * perspectiveScale);
                
                const alpha = Math.min(0.8, perspectiveScale * 1.5) * (1 - t * 0.3);
                ctx.globalAlpha = alpha;
                ctx.lineWidth = Math.max(0.5, 2 - perspectiveScale * 1.5);
                ctx.beginPath();
                ctx.moveTo(leftX, y);
                ctx.lineTo(rightX, y);
                ctx.stroke();
            }
            
            // Draw vertical lines (converging to vanishing point at top-right)
            const numVerticalLines = 20;
            for (let i = 0; i < numVerticalLines; i++) {
                const t = (i + (offset % 1)) / numVerticalLines;
                const perspectiveScale = Math.pow(t, 1.8);
                
                // Lines go from bottom edge toward the vanishing point
                const x = width * perspectiveScale;
                const bottomY = height;
                // Top Y stops at the diagonal mirror line (y = width - x for a 45° diagonal)
                const topY = Math.max(width - x, 0);
                
                const alpha = Math.min(0.6, perspectiveScale * 1.2) * (1 - t * 9);
                ctx.globalAlpha = alpha;
                ctx.lineWidth = Math.max(0.5, 2 - perspectiveScale * 1.5);
                ctx.beginPath();
                ctx.moveTo(x, bottomY);
                ctx.lineTo(x, topY);
                ctx.stroke();
            }
            
            // Draw the diagonal mirror line with a subtle glow
            ctx.globalAlpha = 0.4;
            ctx.lineWidth = 1.5;

            ctx.strokeStyle = gradient;
            ctx.beginPath();
            ctx.moveTo(0, height);
            ctx.lineTo(width, 0);
            ctx.stroke();
            
            // Add subtle glow effect on mirror line
            ctx.globalAlpha = 0.15;
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'transparent';
            ctx.beginPath();
            ctx.moveTo(0, height);
            ctx.lineTo(width, 0);
            ctx.stroke();
            
            offset += 0.015;
            animationId = requestAnimationFrame(draw);
        };
        
        draw();
        
        return () => {
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
        };
    }, [width, height, bgs]);
    
    return (
        <canvas
            id={id}
            width={width - 16}
            height={height}
            style={{ background: 'transparent'}}
        />
    );
}

export default DesignPortfolio;